export default __webpack_public_path__ + "static/img-ei-11-05811be21cbbd4f4482e51ac47e956b9.png";